module.exports = __webpack_public_path__ + "static/media/shutterstock_1315659653.69c9f046.png";